import { render, staticRenderFns } from "./EventColumn.vue?vue&type=template&id=24287b08&scoped=true&"
import script from "./EventColumn.vue?vue&type=script&lang=js&"
export * from "./EventColumn.vue?vue&type=script&lang=js&"
import style0 from "./EventColumn.vue?vue&type=style&index=0&id=24287b08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24287b08",
  null
  
)

export default component.exports